






import { Component, Vue } from 'vue-property-decorator'
import Axios from 'axios'

@Component({})
export default class Success extends Vue {
  success: boolean = false

  async created() {
    const code = this.$route.query.code

    if (!code) {
      return this.$router.replace({
        name: 'spotify auth failed'
      })
    }

    const { data } = await Axios.post('/spotify/token', {
      code
    })

    if (data === false) {
      return this.$router.replace({
        name: 'spotify auth failed'
      })
    }

    await this.$store.dispatch('auth/fetchUserProps')

    this.success = data

    if (this.success) {
      window.close()
    }
  }
}
